import {
  PRESUPUESTADOR_CLEAR_PATENTE,
} from './constants';

export function clearPatente(carIndex = 0) {
  return (dispatch, getState) => {
    const { presupuestador } = getState()

        const entregaUsados = presupuestador.entregaUsados.map((usado, index) => {
          if (index === carIndex) {
            return {
              ...usado,
              patente: '',
              patenteCodeError: null,
              errorPeritaje: '',
            }
          }
            return usado
        })

    dispatch({
      type: PRESUPUESTADOR_CLEAR_PATENTE,
      data: {
        entregaUsados,
      }
    })
  }
}

export function reducer(state, action) {
  if (action.type === 'PRESUPUESTADOR_CLEAR_PATENTE') {
      return {
        ...state,
        ...action.data
      }
  } else {
    return state;
  }
}
